!function () {
    setTimeout(() => document.body.className = 'loaded', 1000);

    let hasIntersectionObserver = false;
    hasIntersectionObserver = false;
    if (typeof window.IntersectionObserver == 'function') {
        hasIntersectionObserver = true;
        document.body.className = 'with-animations';
    }

    { // Navbar
        let navigationCheckbox = document.getElementById('NavigationActivator');
        document.addEventListener('click', function (event) {
            let target = event.target;
            if (target.classList.contains('nav__link')) {
                if (navigationCheckbox.checked) {
                    navigationCheckbox.checked = false;
                }

                if (!target.classList.contains('nav__link--active')) {
                    document.querySelector('.nav__link--active').classList.remove('nav__link--active');
                    target.classList.add('nav__link--active');
                }
            }
        });

        if (hasIntersectionObserver) {
            let observer = new IntersectionObserver((entries) => {
                let length = entries.length;
                for (let i = 0; i < length; ++i) {
                    let entry = entries[i];
                    if (entry.isIntersecting) {
                        document.querySelector('.nav__link--active').classList.remove('nav__link--active');
                        let targetID = entry.target.id;
                        document.querySelector('.nav__link[href="#'+targetID+'"]').classList.add('nav__link--active');
                        return;
                    }
                }
            }, { rootMargin: "-100px" });

            let el = document.querySelectorAll('.navtarget');
            let length = el.length;
            while (length--) {
                observer.observe(el[length]);
            }
        }
    }

    { // Hero
        let hero = document.querySelector('.hero__container');
        hero.addEventListener('click', function (e) {
            if (!e.target.classList.contains('hero__nav__link')) {
                return;
            }

            e.preventDefault();
            if (e.target.classList.contains('active')) {
                return false;
            }

            hero.scrollLeft = hero.querySelector(e.target.getAttribute('href')).offsetLeft;
        });
    }

    // Numbers
    if (hasIntersectionObserver) {
        let animate = (el) => (() => {
            let value = parseFloat(el.textContent.replace(',', '.'));
            let target = parseFloat(el.dataset['target']);
            let step = parseFloat(el.dataset['step']||'1');
            let prefix = el.dataset['prefix']||'';
            let comma = el.dataset['comma']||'';
            if (value < target) {
                value += step;
                if (comma) {
                   value = value.toString().replace('.', ',');
                }
                if (step < 1 && value.indexOf(comma ? ',' : '.') == -1) {
                    value += (comma ? ',' : '.') + '0';
                }
                el.textContent = prefix + value;
                setTimeout(animate(el), 60);
            }
        });

        let observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                let current = entry.target;
                if (entry.isIntersecting) {
                    observer.unobserve(current);
                    setTimeout(animate(current), 0);
                }
            })
        });

        let el = document.querySelectorAll('.js--counter');
        let length = el.length;
        while (length--) {
            el[length].dataset['target'] = parseFloat(el[length].textContent);
            el[length].textContent = (el[length].dataset['prefix'] || '') + '0';
            observer.observe(el[length]);
        }
    }

    // publications__item
    if (hasIntersectionObserver) {
        let observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animated');
                    observer.unobserve(entry.target);
                }
            });
        });

        let el = document.querySelectorAll('.animate');
        let length = el.length;
        while (length--) {
            observer.observe(el[length]);
        }
    }

    { // maps
        let link = document.querySelector('.maps__nav');
        link.addEventListener('click', function(e) {
            let target = e.target;
            if (!target.classList.contains('maps__link')) {
                return;
            }

            e.preventDefault();
            if (target.classList.contains('active')) {
                return;
            }

            link.querySelector('.active').classList.remove('active');
            target.classList.add('active');

            let ref = target.getAttribute('href');
            let svg = document.querySelector('.maps__svg');
            if (ref == '#map1') {
                svg.classList.remove('maps2');
                svg.classList.add('maps1');
            } else {
                svg.classList.remove('maps1');
                svg.classList.add('maps2');
            }
        });
    }

    { // Companies
        let buttons = document.querySelectorAll('.companies__button');
        buttons[0].style.opacity = '0.1';

        let element = document.querySelector('.companies__nav');
        element.addEventListener('click', function(e) {
            let target = e.target;
            if (!target.classList.contains('companies__button')) {
                return;
            }
            
            let container = target.parentElement.parentElement.children[0];
            let width = container.children[0].offsetWidth;
            let left = container.scrollLeft;
            if (target.classList.contains('companies__button--prev')) {
                left -= width;
            } else {
                left += width;
            }

            container.scrollLeft = left;

            if (left <= 0) {
                buttons[0].style.opacity = '0.1';
                buttons[1].style.opacity = '';
            } else {
                buttons[0].style.opacity = '';
                if (left >= ((container.children.length * width) - ((window.innerWidth / width)|0)*width)) {
                    buttons[1].style.opacity = '0.1';
                } else {
                    buttons[1].style.opacity = '';
                }
            }


        });
    }

    { // academic
        let elements = document.querySelectorAll('.academic__container');
        let length = elements.length;
        let fn = (e) => {
            let target = e.target;
            if (!e.target.classList.contains('academic__button')) {
                return;
            }

            e.preventDefault();

            let container = target.parentElement.parentElement.parentElement;
            let content = container.querySelector('.academic__content');
            let image = container.querySelector('.academic__images');

            if (target.classList.contains('academic__button--prev')) {
                let leftContent = Math.max(0, content.scrollLeft - content.children[0].offsetWidth);
                content.scrollLeft = leftContent;

                let leftImage = Math.max(0, image.scrollLeft - image.children[0].offsetWidth);
                image.scrollLeft = leftImage;

                target.nextElementSibling.style.opacity = '';
                if (leftContent <= 0) {
                    target.style.opacity = '0.1';
                }
            } else {
                let maxContent = content.children[0].offsetWidth * content.children.length;
                let leftContent = Math.min(maxContent, content.scrollLeft + content.children[0].offsetWidth);
                content.scrollLeft = leftContent;

                let maxImage = image.children[0].offsetWidth * image.children.length;
                let leftImage = Math.min(maxImage, image.scrollLeft + image.children[0].offsetWidth);
                image.scrollLeft = leftImage;

                target.previousElementSibling.style.opacity = '';
                if (leftContent >= (maxContent - content.children[0].offsetWidth)) {
                    target.style.opacity = '0.1';
                }
            }
        };

        while (length--) {
            let el = elements[length];
            el.querySelector('.academic__button--prev').style.opacity = '0.1';
            el.addEventListener('click', fn);
        }
    }

    { // projects
        let buttons = document.querySelectorAll('.projects__button');
        buttons[0].style.opacity = '0.1';
        let element = document.querySelector('.projects__nav');
        element.addEventListener('click', function(e) {
            let target = e.target;
            if (!e.target.classList.contains('projects__button')) {
                return;
            }

            e.preventDefault();

            let container = target.parentElement.parentElement;
            let content = container.querySelector('.project__relative');
            if (target.classList.contains('projects__button--prev')) {
                let leftContent = Math.max(0, content.scrollLeft - content.children[0].offsetWidth);
                content.scrollLeft = leftContent;
                buttons[0].style.opacity = '0.1';
                buttons[1].style.opacity = '';
            } else {
                let maxContent = content.children[0].offsetWidth * content.children.length;
                let leftContent = Math.min(maxContent, content.scrollLeft + content.children[0].offsetWidth);
                content.scrollLeft = leftContent;
                buttons[0].style.opacity = '';
                buttons[1].style.opacity = '0.1';
            }
        });
    }

    { // conferences
        let buttons = document.querySelectorAll('.conferences__button');
        buttons[0].style.opacity = '0.1';

        let element = document.querySelector('.conferences');
        element.addEventListener('click', function(e) {
            let target = e.target;
            if (!(e.target.classList.contains('conferences__year') || e.target.classList.contains('conferences__circle'))) {
                return;
            }

            e.preventDefault();

            let parent = element.querySelector('.active');
            if (parent) {
                parent.classList.remove('active');
            }

            let container = target.parentElement;
            container.classList.add('active');

            if (container.dataset.index == '0') {
                buttons[0].style.opacity = '0.1';
                buttons[1].style.opacity = '';
            } else {
                if (container.dataset.index == '13') {
                    buttons[1].style.opacity = '0.1';
                } else {
                    buttons[1].style.opacity = '';
                }
                buttons[0].style.opacity = '';
            }

            let halfMargin = ((window.innerWidth - container.offsetWidth) / 2)|0;
            let max = (13 * container.offsetWidth) - (container.offsetWidth - target.offsetWidth) - halfMargin;
            
            let left = -1 * Math.min(max, Number(container.dataset.index) * container.offsetWidth);
            container.parentElement.style.transform = 'translateX('+left+'px)';
        });

        let button = document.querySelector('.conferences__nav');
        element.addEventListener('click', function(e) {
            let target = e.target;
            if (!target.classList.contains('conferences__button')) {
                return;
            }
            
            let item;
            if (target.classList.contains('conferences__button--prev')) {
                item = document.querySelector('.conferences__item.active').previousElementSibling;
            } else {
                item = document.querySelector('.conferences__item.active').nextElementSibling;
            }

            if (item) {
                item.querySelector('.conferences__year').click();
            }
        });
    }
}();